// Store original gtag function if it exists
window._originalGtag = window.gtag;

// Create our wrapper function
window.gtag = function() {
    // Get arguments
    const args = Array.from(arguments);
    const command = args[0];

    // If it's an event, convert it to dataLayer push
    if (command === 'event') {
        const eventName = args[1];
        const params = args[2] || {};

        // Convert gtag parameters to dataLayer format
        window.dataLayer.push({
            'event': eventName,
            'event_category': params.event_category || '',
            'event_action': params.event_action || '',
            'event_label': params.event_label || '',
            // Add any other parameters you commonly use
            ...params
        });

        // Log in development
        if (window.environment !== 'production') {
            console.log('GTM Event:', {
                event: eventName,
                params: params
            });
        }
    }

    // Handle user properties
    else if (command === 'set') {
        const properties = args[1];
        if (properties.user_properties) {
            window.dataLayer.push({
                'event': 'set_user_properties',
                ...properties.user_properties
            });
        }
    }

    // Optionally, still call original gtag if needed
    if (window._originalGtag) {
        window._originalGtag.apply(null, arguments);
    }
};

// Helper function for debugging
window.debugAnalytics = function() {
    console.log('DataLayer contents:', window.dataLayer);
};
